"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseTheme = exports.baseDarkTheme = exports.baseLightTheme = void 0;
exports.baseLightTheme = {
    logos: {
        memoresaLogoName: 'logo_bright.png',
        memoresaLogotypeName: 'logotype_bright.png',
    },
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.38)',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    paper: { main: '#fff', contrast: '#000' },
};
exports.baseDarkTheme = {
    logos: {
        memoresaLogoName: 'logo_bright.png',
        memoresaLogotypeName: 'logotype_bright.png',
    },
    text: {
        primary: '#fff',
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    paper: { main: '#424242', contrast: '#f8f8f8' },
};
exports.baseTheme = {
    logos: {
        memoresaLogoName: 'logo_bright.png',
        memoresaLogotypeName: 'logotype_bright.png',
    },
    hover: { listItem: 'white' },
    type: 'light',
    background: { main: '#f4f4f4', contrast: '#333' },
    paper: { main: '#fff', contrast: '#000' },
    primary: { main: '#033354', contrast: '#ffffff' },
    secondary: {
        main: '#108285',
        contrast: '#ffffff',
    },
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.38)',
    },
    success: { main: '#4caf50', contrast: '#4caf50' },
    error: { main: '#c92814', contrast: '#c92814' },
    info: { main: '#2196f3', contrast: '#2196f3' },
    warning: { main: '#ff9800', contrast: '#ff9800' },
    navbar: {
        bg: '#033354',
        color: '#fff',
        hover: '#ddd',
    },
    fontFamily: 'Montserrat',
    disabled: '#cacaca',
    divider: 'rgba(0, 0, 0, 0.12)',
};
